import { ADMIN_ROUTES, PARENT_EMAIL_ROUTES, ROUTES } from './vars';

export const FIRST_ASSESSMENT_DATE = '1970-01-02T00:00:00.000+01:00';
export const LAST_ASSESSMENT_DATE = '1970-01-03T00:00:00.000+01:00';

export const API_ERRORS = {
  NOT_ENOUGH_SUBSCRIPTIONS: 'Not enough subscriptions',
  USERNAME_ALREADY_EXISTS: 'Username Already Registered',
  EMAIL_ALREADY_EXISTS: 'The email already exists',
  UPN_ALREADY_EXISTS: 'UPN already exists',
  DUPLICATE_STUDENT: 'Student already exists',

  GUARDIANS_IMPORT_EMPTY: 'Provided file appears to be empty',
  GUARDIANS_IMPORT_ERROR: 'Encountered error while parsing the file',
  GUARDIANS_IMPORT_HEADERS: 'Provided file doesn\'t contain valid headers',
  GUARDIANS_IMPORT_EMAIL: 'Provided file contains invalid email address',
  GUARDIANS_IMPORT_UPN: 'Provided file contains an incorrect UPN',
};

export const PUBLIC_PATHS = [
  `${ROUTES.parent_email}${PARENT_EMAIL_ROUTES.signup}`,
  `${ROUTES.parent_email}${PARENT_EMAIL_ROUTES.consent}`,
  `${ROUTES.parent_email}${PARENT_EMAIL_ROUTES.unsubscribe}`,
  ADMIN_ROUTES.login,
  ADMIN_ROUTES.weeklyLeadersEmails,
];
